const NotificationTypes = {
	SELECT_NOTIFICATIONS: 'SELECT_NOTIFICATIONS',
	ADD_NOTIFICATION: 'ADD_NOTIFICATION',
	GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
}

export default NotificationTypes
